import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "p-d-flex p-flex-row p-m-4"
}
const _hoisted_3 = { class: "p-mr-2" }
const _hoisted_4 = { class: "fa fa-question-circle" }
const _hoisted_5 = { class: " p-fluid p-field kn-flex" }
const _hoisted_6 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_ctx.businessModel)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.businessModel.properties, (property, index) => {
          return (_openBlock(), _createBlock("div", { key: index }, [
            (property['structural.sqlFilter'])
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _withDirectives(_createVNode("i", _hoisted_4, null, 512), [
                      [
                        _directive_tooltip,
                        _ctx.$t('metaweb.filterHelpMessage'),
                        void 0,
                        { top: true }
                      ]
                    ])
                  ]),
                  _createVNode("div", _hoisted_5, [
                    _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('common.sqlExpression')), 1),
                    _createVNode(_component_Textarea, {
                      class: "kn-material-input",
                      modelValue: property['structural.sqlFilter'].value,
                      "onUpdate:modelValue": ($event: any) => (property['structural.sqlFilter'].value = $event),
                      onBlur: _ctx.updateMeta
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}